import { SportModel } from "../..";
const sportOrderToHide = -4;
export const sportMapperFactory = (countMapper, orders = []) => {
    return (sport) => (new SportModel({
        id: sport.id || "",
        name: sport.name || "",
        order: cmsOrderMapper(orders, true, sport.id, sport.order),
        numberOfEvents: countMapper(sport)
    }));
};
export const personalizedSportMapperFactory = (orders) => {
    return (sport, index) => (new SportModel({
        id: sport.id,
        name: sport.name,
        order: cmsOrderMapper(orders, false, sport.id, index + 1),
        numberOfEvents: sport.numberOfEvents
    }));
};
export const preLiveCountMapper = (sport) => sport.fixturesCount || 0;
export const liveCountMapper = (sport) => (sport.liveFixturesTotalCount || 0) + (sport.liveOutrightsTotalCount || 0);
export const todayCountMapper = (sport) => sport.fixturesCount || 0;
const cmsOrderMapper = (orders, useCmsOrder, sportId, sportOrder) => {
    const order = sportOrder || 0;
    if (orders.length === 0) {
        return order;
    }
    const cmsSportOrder = orders.find(o => `${o.sportId}` === sportId);
    if (cmsSportOrder === undefined || !cmsSportOrder.activeInCms) {
        return sportOrderToHide;
    }
    return useCmsOrder ? cmsSportOrder.order : order;
};
//# sourceMappingURL=SportDataMapper.js.map